import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
    selector: 'syn-login',
    styleUrls: ['login.component.scss'],
    templateUrl: 'login.component.html'
})

export class LoginComponent {
    constructor(
        private authService: AuthService,
        private route: ActivatedRoute,
    ) { }

    public login(): void {
        this.authService.loginWithRedirect({
            authorizationParams: {
                redirect_uri: window.location.origin
            },
            appState: {
                target: this.route.snapshot.queryParamMap.get('redirect')
            }
        });
    }
}
